/**
 * accountStore — dünner Lade-Helfer für die Account-/Nutzerverwaltung
 * (Backend, Spec §7.3). Reine Delegation an AccountService; der Server
 * filtert rollenabhängig (Admin: alle, Brand-Admin: eigene Brand).
 */

import { AccountService } from './AccountService'
import type { CreateAccountPayload } from './AccountService'
import { brandScope } from '../utils/scope'
import type { Account, Session } from '../types'

/** Lädt die für die Session sichtbaren Accounts. */
export async function loadAccounts(session: Session): Promise<Account[]> {
  return AccountService.list(brandScope(session).scopedBrandParam())
}

/** Lädt einen einzelnen Account (für die Detailseite). */
export async function getAccount(id: string): Promise<Account> {
  return AccountService.get(id)
}

/** Aktualisiert Anzeigename/Aktiv-Status eines Accounts (nur Admin, Backend-Guard). */
export async function updateAccount(id: string, patch: { displayName?: string; active?: boolean }): Promise<Account> {
  return AccountService.update(id, patch)
}

/** Legt einen neuen Admin-/Brand-Admin-Account an (nur Super-Admin, Backend-Guard). */
export async function createAccount(payload: CreateAccountPayload): Promise<Account> {
  return AccountService.create(payload)
}

/** Sendet die Einladungs-Mail (7-Tage-Link) an ein Admin-Konto erneut. */
export async function resendInvite(id: string): Promise<void> {
  return AccountService.resendInvite(id)
}
